import styled from "styled-components";

export const StyledWebhookCellWrapper = styled.div`
    padding: 20px 8px;
`;
